import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import RoutePath from '../utils/routes/RoutePath';
import { toast } from 'react-toastify';
import Constants from '../utils/Constants';
import VendorWard from '../component/VendorWard';

class VendorWardList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
        }
    }

    componentDidMount() {
        this.getVendorWardList()
    }

    getVendorWardList = () => {
        this.props.getVendorWardList({}, () => { })
    }

    updateStatus = (id, active) => {
        const updateParams = {
            id,
            isActive: active ? 0 : 1
        }
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getVendorWardList()
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.props.updateVendorWard(updateParams, callback, false)
    }

    addVendorWard = () => {
        this.props.history.push(RoutePath.VENDOR_WARD_ADD)
    }

    clearSearch = () => {
        this.setState({ searchText: '' })
    }

    render() {
        const { searchText } = this.state;
        const { getVendorRoomService = {} } = this.props
        const { isLoading, vendorWardListData } = getVendorRoomService
        const search = (searchText || "").trim().toLowerCase();
        const filteredWards = (vendorWardListData?.wards || []).filter((ward) => {
            if (!search) return true;
            const wardName = (ward?.wardName || "").toLowerCase();
            const headName = (ward?.HeadUser?.fullName || ward?.HeadUser?.email || "").toLowerCase();
            return wardName.includes(search) || headName.includes(search);
        });
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div className='addButton'>
                            <div className="add-btn">
                                <button className="btn add-item" type="button" onClick={() => this.addVendorWard()}><i className="fa-solid fa-plus me-3"></i>Add Ward</button>
                            </div>
                            <div className="add-btn search-box">
                                <input
                                    className="form-control search-input"
                                    placeholder="Search by ward / head nurse"
                                    value={searchText}
                                    onChange={(e) => this.setState({ searchText: e.target.value })}
                                />
                                {searchText ? <button type="button" className="search-clear-btn" onClick={this.clearSearch}>x</button> : null}
                            </div>
                        </div>
                        <VendorWard wardList={filteredWards} updateStatus={(id, active) => this.updateStatus(id, active)} />
                    </div>
                </div>

                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getVendorRoomService: Actions.getVendorRoomService(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getVendorWardList: Actions.getVendorWardList,
    updateVendorWard: Actions.updateVendorWard,
})(VendorWardList));
